import { render, staticRenderFns } from "./wv-peer-feedback-email.vue?vue&type=template&id=07634c19&scoped=true&"
import script from "./wv-peer-feedback-email.vue?vue&type=script&lang=js&"
export * from "./wv-peer-feedback-email.vue?vue&type=script&lang=js&"
import style0 from "./wv-peer-feedback-email.vue?vue&type=style&index=0&id=07634c19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07634c19",
  null
  
)

export default component.exports